export const CREDENTIALS = 'credentials'
export const NYLAS = 'nylas'
export const NYLAS_V3 = 'nylas_v3'
export const NYLAS_KEY = 'account'
export const FOLDER = 'folder_external_ids'
export const EXCLUDE_FOLDER = 'exclude_folder_external_ids'
